declare global {
  interface Window {
    env: any;
  }
}
type EnvType = {
  [x: string]: any;
};
export const env: EnvType = { ...process.env, ...window.env };
